export default "__VITE_ASSET__Boyt3y8U__"